PJQ.views.schedule.TaskListDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Data-Table-Header-Task-List')
        },
        language: {
            emptyTable: 'No tasks were found',
            zeroRecords: "No tasks were found"
        },
        settings: null,
        onTaskEdit: null,
        onTaskDelete: null,
        paging: false,
        scrollRows: true,
        isShowCriticalPath: false,
        isAdmin: true,
        level: 0,
        order: [3, 'asc'],
        orderCookie: PJQ.constants.cookies.SCHEDULE_TASK_LIST_ORDER
    },
    events: {
        'click .btn-edit-task': 'editTaskClicked',
        'click .btn-delete-task': 'deleteTaskClicked',
        'keyup .datatable-search': 'search',
        'click .task-list-clear-filters': 'clearFilters'
    },
    headerData: function () {
        return {
            statuses: this.model.statuses
        };
    },
    afterDataTableRender: function () {
        let self = this;
        if(_.size(this.model.tasks.models) < 200) {
            this.dataTable.rows().every(function () {
                let task = this.data();
                if (task.get('isSummaryTask')) {
                    self.toggleChildRow(this);
                }
            });
        }

        if(typeof this.options.afterTableRendered === 'function'){
            this.options.afterTableRendered();
        }
    },
    beforeDataTableRender: function () {
        this.options.hasCompleteStatus = false;
        this.preferences = this.options.project ? this.options.project.preferences : PJQ.app.session.preferences;
        _.each(this.model.statuses.models, function (model) {
            if (model.get('name').toLowerCase().includes('complete')) {
                this.options.hasCompleteStatus = true;
            }
        }, this)

        this.statusFilterPicker = new PJQ.inputs.Selectpicker({
            el: this.$('select.task-list-filter'),
            defaultValue: this.options.filter,
            isMultiple: true,
            isIntChoices: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                this.setFilter('status', value);
            }, this)
        });
    },
    getContextMenuOptions: function () {
        return {
            actions: [
                {
                    name: 'Edit',
                    iconClass: 'fal fa-pencil',
                    onClick: _.bind(function (row) {
                        this.editTask(row.data());
                    }, this),
                    isShown: _.bind(function (row) {
                        return true;
                    }, this)
                },
                {
                    name: 'New Dependency',
                    iconClass: 'fal fa-plus',
                    onClick: _.bind(function (row) {
                        let newTask = row.data().newDependencyTask();
                        this.model.tasks.add(newTask);
                        this.editTask(newTask);
                    }, this),
                    isShown: _.bind(function (row) {
                        return false;
                    }, this)
                },
                {
                    name: 'New Successor',
                    iconClass: 'fal fa-plus',
                    onClick: _.bind(function (row) {
                        let newTask = row.data().newSuccessorTask();
                        this.model.tasks.add(newTask);
                        this.editTask(newTask);
                    }, this),
                    isShown: _.bind(function (row) {
                        return false;
                    }, this)
                },
                {
                    name: 'Add to Summary Task',
                    onClick: _.bind(function (row) {
                        let task = row.data();
                        this.addToSummaryTaskClicked(task);
                    }, this),
                    isShown: _.bind(function (row) {
                        let task = row.data();
                        if(task) {
                            return !this.options.settings.get('lockSchedule');
                        }
                        else{
                            return false;
                        }
                    }, this)
                },
                {
                    name: 'Remove from Summary Task',
                    onClick: _.bind(function (row) {
                        let task = row.data();
                        this.removeSummaryTask(task);
                    }, this),
                    isShown: _.bind(function (row) {
                        let task = row.data();
                        if(task) {
                            return task.get('summaryTaskId') > 0 && !this.options.settings.get('lockSchedule');
                        }
                        else{
                            return false;
                        }
                    }, this)
                },
                {
                    name: 'Delete',
                    iconClass: 'fal fa-trash',
                    isDanger: true,
                    onClick: _.bind(function (row) {
                        this.deleteTask(row.data());
                    }, this),
                    isShown: _.bind(function (row) {
                        return true;
                    }, this)
                }
            ]
        };
    },
    addToSummaryTaskClicked: function (task) {
        new PJQ.views.charts.SummaryTaskModal({
            tasks: this.model.tasks,
            task: task,
            project: this.options.project,
            schedule: this.options.schedule,
            onSave: _.bind(function (task, summaryTaskId, isNewTask = false) {
                if (typeof this.options.onTaskUpdateSummary === 'function') {
                    this.options.onTaskUpdateSummary(task, summaryTaskId, isNewTask);
                }
            }, this)
        });
    },
    search: function (searchText) {
        searchText = this.getSearchText();

        this.searchDataTable(this.dataTable, searchText);
    },
    searchDataTable: function(dataTable, searchText) {
        searchText = searchText.toLowerCase();
        let hasVisibleChildren = false,
            self = this;

            // Filter the collection
            let filteredModels = this.model.tasks.filter(function (model) {
                // Check each attribute in the model
                return _.some(model.attributes, function (value) {
                    // Ensure the value is a string and perform a case-insensitive comparison
                    if ((typeof value === 'string' || value instanceof String) && _.size(value) > 0) {
                        return value.toLowerCase().includes(searchText);
                    }
                    return false;
                });
            });

            // Extract summaryTaskIds from filteredModels
            let summaryTaskIds = _.uniq(filteredModels.map(function (model) {
                return model.get('summaryTaskId');
            }));

            // Include models whose id matches one of the summaryTaskIds
            this.model.tasks.forEach(function (model) {
                if (summaryTaskIds.includes(model.id) && !_.findWhere(filteredModels, {id: model.id})) {
                    filteredModels.push(model);
                }
            });

            dataTable.rows().every(function () {
                let row = this;
                let rowData = row.data();
                let childTable = row.child.isShown() && $(row.node()).next('tr').find('table').DataTable();


                // Check if the current row matches the search text
                let rowMatches = _.contains(filteredModels, rowData);


                // Recursively search in child DataTable, if present
                let childMatches = false;
                if (childTable) {
                    childMatches = self.searchDataTable(childTable, searchText);
                }

                // Check row visibility
                let showRow = rowMatches || childMatches;
                row.node().style.display = showRow ? '' : 'none';
                // Rows with children have an extra <tr> after the actual row. If it isn't hidden there will be a grey line for every empty child table.
                // Hide that row if the row is hidden, or show if not.
                if (!$(row.node()).next('tr').hasClass('odd') && !$(row.node()).next('tr').hasClass('even')) {
                    showRow ? $(row.node()).next('tr').show() : $(row.node()).next('tr').hide();
                }

                if (showRow) hasVisibleChildren = true;
            });

            return hasVisibleChildren;
    },
    removeSummaryTask: function (task) {
        if (typeof this.options.onTaskUpdateSummary === 'function') {
            this.options.onTaskUpdateSummary(task, 0);
        }
    },
    getRowChildData: function (row) {
        if(row && row.length > 0) {
            return this.model.tasks.where({summaryTaskId: row.data().id});
        }
    },
    getRowChildTable: function (opts) {
        return new PJQ.views.schedule.TaskListDataTable(_.extend(opts, {
            model: this.model,
            onTaskEdit: this.options.onTaskEdit,
            onTaskDelete: this.options.onTaskDelete,
            onTaskUpdateSummary: this.options.onTaskUpdateSummary,
            hasCompleteStatus: this.options.hasCompleteStatus,
            scrollRows: false,
            hideColumnHeaders: true,
            settings: this.options.settings,
            level: this.options.level + 1,
            summaryTaskId: this.model.tasks.get(opts.parentId).id,
            onChildTableRendered: _.bind(function(){
                this.search(this.getSearchText);
            }, this)
        }));
    },
    getColumns: function () {
        let columns = [];

        columns.push({
            "columnData": "taskName",
            "data": "attributes.name",
            "title": "Name",
            "width": "20%",
            "render": (data, type, row) => {
                let padding = this.options.level * 15,
                    html = '<i class="fal fa-plus-circle toggle-row ' + (!row.get('isSummaryTask') ? 'invisible' : '') + '" data-type="" data-id="' + row.id + '" style="cursor: pointer"></i>';

                html += '<a class="btn-edit-task ml-2" href="javascript:void(0)" data-id="' + row.id + '">' + data + '</a>';

                return '<div style="padding-left:' + padding.toString() + 'px;">' + html + '</div>';
            },
        });

        columns.push({
            "columnData": "duration",
            "data": "attributes.duration",
            "title": "Duration",
            "width": "50px",
        });

        columns.push({
            "columnData": "start",
            "data": {
                "_": function (row) {
                    return new Date(row.attributes.start);
                },
                "filter": "attributes.start",
                "display": function (row) {
                    if (row.get('start') == null) {
                        return '';
                    }

                    let offsetClass = '';
                    if (row.get('finish') != null) {
                        let active = PJQ.helpers.dateHelpers.checkDateBetweenDays(row.get('start'), row.get('finish')),
                            overdue = row.get('percentComplete') < 100 && PJQ.helpers.dateHelpers.checkDateIsBeforeToday(row.get('finish'));
                        if (active) {
                            offsetClass = 'text-primary font-weight-medium';
                        } else if (overdue) {
                            offsetClass = 'text-danger font-weight-bold';
                        } else {
                            let offset = PJQ.helpers.dateHelpers.getDateDaysDiff(row.get('finish'), new Date());
                            if (offset < 0) {
                                offsetClass = 'text-muted';
                            }
                        }
                    }
                    return '<span class="' + offsetClass + '">' + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('start')), PJQ.helpers.dateHelpers.dateFormats.DATE) + '</span>';
                }
            },
            "group": function (data, groupBy) {
                switch (groupBy) {
                    case PJQ.constants.schedule.taskList.groupBy.MONTH:
                        return data.get('start') ? PJQ.helpers.dateHelpers.getDateString(data.get('start'), PJQ.helpers.dateHelpers.dateFormats.MONTH_YEAR) : null;
                    case PJQ.constants.schedule.taskList.groupBy.WEEK:
                        let startOfWeek = moment(data.get('start')).startOf('week').toDate(),
                            endOfWeek = moment(data.get('start')).endOf('week').toDate();
                        return data.get('start') != null ? PJQ.helpers.dateHelpers.getDateString(startOfWeek, PJQ.helpers.dateHelpers.dateFormats.DATE) + ' - ' + PJQ.helpers.dateHelpers.getDateString(endOfWeek, PJQ.helpers.dateHelpers.dateFormats.DATE) : null;
                    case PJQ.constants.schedule.taskList.groupBy.DAY:
                        return data.get('start') != null ? PJQ.helpers.dateHelpers.getDateString(data.get('start'), PJQ.helpers.dateHelpers.dateFormats.DATE) : null;
                }
                return 'N/A';
            },
            "width": "100px",
            "title": "Start"
        });

        columns.push({
            "columnData": "finish",
            "data": {
                "_": function (row) {
                    return new Date(row.attributes.finish);
                },
                "filter": "attributes.finish",
                "display": function (row) {
                    if (row.get('finish') == null) {
                        return '';
                    }

                    let offsetClass = '';
                    if (row.get('start') != null) {
                        let active = PJQ.helpers.dateHelpers.checkDateBetweenDays(row.get('start'), row.get('finish')),
                            overdue = row.get('percentComplete') < 100 && PJQ.helpers.dateHelpers.checkDateIsBeforeToday(row.get('finish'));
                        if (active) {
                            offsetClass = 'text-primary font-weight-medium';
                        } else if (overdue) {
                            offsetClass = 'text-danger font-weight-bold';
                        } else {
                            let offset = PJQ.helpers.dateHelpers.getDateDaysDiff(row.get('finish'), new Date());
                            if (offset < 0) {
                                offsetClass = 'text-muted';
                            }
                        }
                    }
                    return '<span class="' + offsetClass + '">' + PJQ.helpers.dateHelpers.getDateString(new Date(row.get('finish')), PJQ.helpers.dateHelpers.dateFormats.DATE) + '</span>';
                }
            },
            "width": "100px",
            "title": "Finish"
        });

        let groupByGroup = function (data) {
            let gr = data.get('groups');
            if (_.size(gr) === 0) {
                return 'None';
            }

            return _.map(gr, function (group) {
                return group.groupName;
            }).join(', ');
        }
        columns.push({
            "attribute": "groups",
            "columnData": function (row) {
                return row.get('groups');
            },
            "isArrayGroup": true,
            "group": function (data) {
                return groupByGroup(data);
            },
            "render": function (data, type, row) {
                if (type === 'sort') {
                    return groupByGroup(row);
                }

                if (_.size(row.groups.models) === 0) {
                    return 'None';
                }

                return _.map(row.groups.models, function (group) {
                    return group.get('groupName');
                }).join(', ');
            },
            "width": "200px",
            "title": this.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL) ?? "Trades"
        });

        let groupByAssignee = function (data) {
            let as = data.get('assignees');
            if (_.size(as) === 0) {
                return 'Nobody';
            }

            return _.map(as, function (assignee) {
                return assignee.contactName;
            }).join(', ');
        }
        columns.push({
            "attribute": "assignees",
            "columnData": function (row) {
                return row.get('assignees');
            },
            "render": function (data, type, row) {
                if (_.size(row.assignees.models) === 0) {
                    return 'Nobody';
                }

                return _.map(row.assignees.models, function (assignee) {
                    let res = assignee.get('contactName');
                    return _.size(res) > 0 ? res : assignee.get('companyName');
                }).join(', ');
            },
            "width": "150px",
            "title": "Assignees"
        });

        columns.push({
            "data": "notes",
            "title": "Notes",
            "render": function (data, type, row) {
                return row.get('notes');
            }
        });

        columns.push({
            "columnData": "percentComplete",
            "data": {
                "_": function (row) {
                    return row.status != null ? row.status.get('sortOrder') : 0;
                },
                "filter": "attributes.percentComplete",
                "display": function (row) {
                    let percent = row.get('percentComplete'),
                        progressBg;
                    if (percent < 60) {
                        progressBg = 'bg-danger';
                    } else if (percent >= 60 && percent < 100) {
                        progressBg = 'bg-warning';
                    } else {
                        progressBg = 'bg-success';
                    }
                    return '<div class="progress ht-25p"><div class="progress-bar ' + progressBg + ' text-white fs-16" role="progressbar" style="width:' + percent + '%">' + percent + '%</div></div>';
                }
            },
            "width": "125px",
            "title": "Progress"
        });

        columns.push({
            "columnData": "status",
            "data": {
                "_": function (row) {
                    return row.status != null ? row.status.get('sortOrder') : 0;
                },
                "filter": "attributes.statusId",
                "display": _.bind(function (row) {
                    if (row.status == null) {
                        return '';
                    }

                    let overdue = row.get('percentComplete') < 100 && PJQ.helpers.dateHelpers.checkDateIsBeforeToday(row.get('finish')),
                        enableOverdueStatus = this.options.settings.get('enableOverdueStatus');
                    if (row.get('finish') != null && this.options.hasCompleteStatus && (row.status == null || row.status.get('name').toLowerCase() !== 'complete') && overdue && enableOverdueStatus) {
                        return '<span class="text-danger font-weight-bold">Overdue</span>';
                    } else {
                        return '<span style="color:' + row.status.get('color') + '">' + row.status.get('name') + '</span>';
                    }
                }, this)
            },
            "width": "100px",
            "title": "Status"
        });

        columns.push({
            "title": '',
            "render": _.bind(function () {
                let result = '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-edit-task mr-1" title="Edit Task"><i class="fal fa-pencil"></i></button>';
                if (this.options.isAdmin) {
                    result += '<button type="button" class="btn btn-danger btn-delete-task" title="Delete Task"><i class="fal fa-trash-alt"></i></button>';
                }
                result += '</div>';
                return result;
            }, this),
            "orderable": false,
            "searchable": false,
            "width": "80px",
            "className": "text-center",
            "visible": true
        });

        return columns;
    },
    createdRow: function (row, data) {
    },
    editTaskClicked: function (e) {
        e.stopPropagation();

        let target = $(e.currentTarget),
            row = this.getRow(target.closest('tr'));
        this.editTask(row.data());
    },
    deleteTaskClicked: function (e) {
        e.stopPropagation();

        let target = $(e.currentTarget),
            row = this.getRow(target.closest('tr'));
        this.deleteTask(row.data());
    },
    onRowDoubleClick: function (row) {
        this.editTask(row.data());
    },
    editTask: function (task) {
        if (typeof this.options.onTaskEdit === 'function') {
            this.options.onTaskEdit(task);
        }
    },
    deleteTask: function (task) {
        if (typeof this.options.onTaskDelete === 'function') {
            this.options.onTaskDelete(task);
        }
    },
    getFilterData: function () {
        // let statusFilter = this.getFilter('status'),
        //         filtered = _.filter(this.model.tasks.models, function (task) {
        //             return !task.get('isSummaryTask');
        //         }, this);
        //     if (_.size(statusFilter) > 0) {
        //         filtered = _.filter(filtered, function (task) {
        //             return statusFilter.indexOf(task.status.id) !== -1;
        //         }, this);
        //     }

        let statusFilter = this.getFilter('status'),
            filtered = _.filter(this.model.tasks.models, function (task) {
                let summaryTaskId = task.get('summaryTaskId');
                return this.options.summaryTaskId !== task.id && (this.options.summaryTaskId === summaryTaskId || (this.options.summaryTaskId == null && summaryTaskId == null));
            }, this);
        if (_.size(statusFilter) > 0) {
            filtered = _.filter(filtered, function (task) {
                return statusFilter.indexOf(task.status.id) !== -1;
            }, this);
        }

        return filtered;
    },
    clearFilters: function () {
        this.statusFilterPicker.deselectAll();
        this.searchBar.val('');
        this.filterBidders();
    }
});

PJQ.views.schedule.TaskList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Task-List'),
        onTaskEdit: null,
        onTaskDelete: null,
        isShowCriticalPath: false,
        isAdmin: true
    },
    events: {},
    renderData: function () {
        return {
            model: this.model
        };
    },
    beforeRender: function () {
        if (this.options.settings == null) {
            if (this.options.project != null) {
                this.options.project.fetchScheduleSettings(_.bind(function (settingsRes) {
                    this.settings = settingsRes;
                }, this));
            } else {
                PJQ.app.session.fetchScheduleSettings(_.bind(function (settingsRes) {
                    this.settings = settingsRes;
                }, this));
            }
        }
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.schedule.TaskListDataTable({
            el: this.$('.task-list'),
            model: this.model,
            isShowCriticalPath: this.options.isShowCriticalPath,
            isAdmin: this.options.isAdmin,
            settings: this.settings,
            afterTableRendered: _.bind(function(){
                if(typeof this.options.afterTableRendered === 'function'){
                    this.options.afterTableRendered();
                }
            }, this),
            onTaskEdit: _.bind(function (task) {
                if (typeof this.options.onTaskEdit === 'function') {
                    this.options.onTaskEdit(task);
                }
            }, this),
            onTaskDelete: _.bind(function (task) {
                if (typeof this.options.onTaskDelete === 'function') {
                    this.options.onTaskDelete(task);
                }
            }, this),
            onTaskUpdateSummary: _.bind(function (task, summaryTaskId) {
                if (typeof this.options.onTaskUpdateSummary === 'function') {
                    this.options.onTaskUpdateSummary(task, summaryTaskId);
                }
            }, this),
        });

        if(this.options.project != null){
            this.options.project.off('scheduleTaskChanged');
            this.options.project.on('scheduleTaskChanged', function(task, isNew, isSummaryUpdate = false, isDelete = false){
                let $scroll = this.dataTable.$el.find('.dataTables_scrollBody'),
                    scrollY = $scroll.scrollTop();

                if(isSummaryUpdate){
                    this.dataTable.render();
                } else if(task.get('summaryTaskId')){
                    // levels tracks how many child tables we'll need to go through to get to the target child table
                    // Work from the top down to find the child table we want
                    let levels = 0,
                        summaryTaskIds = [],
                        taskTable = null,
                        // findSummaryTask will start at the edited task, and work its way up to find the highest level task
                        findSummaryTask = _.bind(function(t){
                            levels++;
                            if(t.get('summaryTaskId')){
                                let summaryTask = this.model.tasks.get(t.get('summaryTaskId'));
                                summaryTaskIds.push(summaryTask.id);
                                // If the summary task also has a summaryTaskId, then keep going up
                                if(summaryTask.get('summaryTaskId')){
                                    findSummaryTask(summaryTask);
                                }
                            }
                        }, this);

                    // initial call of findSummaryTask
                    findSummaryTask(task);

                    // Once we've found all the relevant tasks then we need to work from the top down to find the child table.
                    let findDataTable = _.bind(function(table){
                        // find the relevant child table
                        let childTable = _.find(table.options.childDataTables, function(child){
                            return summaryTaskIds.find((id) => id === child.options.summaryTaskId)
                        }, this);

                        // Reduce the levels. If levels is 0 then we've found the target table, otherwise we need to keep going.
                        levels--;
                        if(levels === 0){
                            taskTable = childTable;
                        } else{
                            findDataTable(childTable);
                        }
                    }, this);

                    // initial call of findDataTable. Will always start with the highest level table
                    findDataTable(this.dataTable);

                    // Assuming we've found the table successfully, then we can refresh or add a row. If we didn't find the table, then just re-render the whole table.
                    if(taskTable != null) {
                        if(isDelete){
                            let row = taskTable.getRow(task.cid);
                            if(row){
                                taskTable.removeRow(row);
                            }
                        }
                        else if (isNew) {
                            taskTable.addRow(task);
                        } else {
                            taskTable.refresh();
                        }
                    }
                    else{
                        this.dataTable.render();
                    }
                } else{
                    if(isDelete){
                        let row = this.dataTable.getRow(task.cid);
                        if(row){
                            this.dataTable.removeRow(row);
                        }
                    }
                    else if(isNew){
                        this.dataTable.addRow(task);
                    } else{
                        this.dataTable.refresh();
                    }
                }
                this.dataTable.$el.find('.dataTables_scrollBody').scrollTop(scrollY);
            }, this);
        }
    }
});
